<template>
	<div>
		<practice-offer-deleted />
		<practice-upcoming-bookings />
		<practice-booking-history />
	</div>
</template>

<script>
import PracticeOfferDeleted from '@/components/ui/dashboard/practice/cards/PracticeOfferDeleted';
import PracticeUpcomingBookings from '@/components/ui/dashboard/practice/dropdowns/PracticeUpcomingBookings';
import PracticeBookingHistory from '@/components/ui/dashboard/practice/dropdowns/PracticeBookingHistory';

export default {
	name: 'PracticeSuccessOfferDeleted',
	components: {
		PracticeOfferDeleted,
		PracticeUpcomingBookings,
		PracticeBookingHistory,
	},
	data: () => ({}),
};
</script>
